import styled from 'styled-components';

export const Body = styled.div`
  display: flex;
  gap: 1rem;

  @media (max-width: 900px) {
    flex-direction: column;
  }

  @media (max-width: 450px) {
    gap: 0.5rem;
  }
`;

export const Container = styled.div`
  background-color: ${({ theme }) => theme.colors.background_white};
  margin-top: 3rem;
  width: 79%;
  padding-right: 1rem;

  h2 {
    color: ${({ theme }) => theme.colors.text};
    margin: 2rem 0 1rem 0;
    font-size: 1.3rem;
  }

  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-left: auto;

    h1 {
      font-weight: 300;
      color: ${({ theme }) => theme.colors.tertiary_500};
      margin: 0;
      font-size: 18px;
    }

    .buttonsImport {
      display: flex;
      gap: 0.5rem;

      button {
        display: flex;
        align-items: center;
        color: ${({ theme }) => theme.colors.tertiary_500};
        text-decoration: underline;
        border: none;
        background: none;
        cursor: pointer;

        svg {
          padding: 0.5rem;
        }

        transition: opacity 0.2s;
        &:hover,
        &:focus {
          opacity: 0.55;
        }
      }
    }
  }

  .branchesList {
    display: flex;
    flex-wrap: wrap;
    gap: 1rem;
  }

  .branch {
    background: ${({ theme }) => theme.colors.background};
    width: 30%;
    max-width: 28rem;
    height: 2rem;
    border-radius: 1rem;
    padding: 0.8rem 1rem 1rem 0.8rem;

    .address {
      margin-bottom: 1rem;

      p {
        font-size: 1.1rem;
        color: ${({ theme }) => theme.colors.primary};
      }

      .street {
        border-bottom: 1px solid ${({ theme }) => theme.colors.primary};
      }
    }

    .headerBranch {
      display: flex;
      justify-content: space-between;
      align-items: center;

      h1 {
        font-size: 20px;
        font-weight: 600;
        margin: 0;
        width: 89%;
        color: ${({ theme }) => theme.colors.primary};
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }

      div {
        display: flex;
      }

      .MuiButton-root {
        min-width: 10%;
        width: 1rem;
        height: 1rem;
        padding: 0;
      }

      .delete {
        svg {
          height: 1.1rem;
        }

        transition: opacity 0.2s;
        &:hover,
        &:focus {
          opacity: 0.55;
        }
      }
    }
  }

  @media (max-width: 900px) {
    width: auto;
    margin-top: 0;
    padding: 1rem 1.5rem;
  }

  @media (max-width: 450px) {
    padding: 0 1.5rem;

    .header {
      flex-direction: column;

      h1 {
        display: none;
      }

      .buttonsImport {
        flex-direction: column;
        width: 100%;
        gap: 0;

        button {
          padding: 0;

          svg {
            padding: 0.5rem;
          }
        }
      }
    }

    .branch {
      width: 100%;
      padding: 0.5rem;
    }
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;

export const Content = styled.div`
  display: flex;
  gap: 3rem;
  padding: 1.5rem;
  background: ${({ theme }) => theme.colors.background};
  border-radius: 1rem;

  .statesContainer {
    width: 30%;
  }
  .districtContainer {
    width: 30%;
  }
  .courtContainer {
    width: 30%;
  }
  .cnpj {
    width: 75%;
  }

  .addCourt {
    display: flex;
    justify-content: flex-end;
    width: 30%;
  }

  @media (max-width: 900px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 2rem;

    .statesContainer,
    .districtContainer,
    .courtContainer {
      width: 100%;
    }
  }

  @media (max-width: 450px) {
    flex-direction: column;
    padding: 1rem;
    height: fit-content;
    gap: 1rem;

    .addCourt {
      justify-content: center;
      width: 100%;
    }
  }

  @media (max-width: 320px) {
    padding: 0.5rem;
  }
`;
